export default {
  loaded: false,
  loading: true,
  data: {},
  types: null,
  miniBranding: {}
}
